// extracted by mini-css-extract-plugin
export default {"modal-wrapper":"DeleteFulfillmentModal_modal-wrapper__rqhOl"};